import React from 'react';
import './components.css';
import eurovis from '../data/eurovis2024.pdf';
import confides from '../data/visshort2024.pdf';


function Publication(props){
    let authors = props.publication.authors.split(', ');
    let bold_index = 0;
    let spacer = '';
    let repolink = null;
    let link = null;
    for (let i = 0; i < authors.length; i++){
        if(authors[i] === 'Sunwoo Ha'){
            authors[i] = <b>Sunwoo Ha</b>;
            bold_index = i;
            if (i !== 0){
                spacer = ', '
            }
        }
    }
    let authors1 = authors.slice(0,bold_index).join(', ');
    let authors2 = authors.slice(bold_index+1).join(', ');
    if (props.publication.repolink !== ""){
        repolink = <a href={props.publication.repolink} target="_blank" rel="noopener noreferrer">Repo</a>
    }

    if(props.publication.link === "eurovis"){
        link = <a href={eurovis} target="_blank" rel="noopener noreferrer">PDF</a>
    } else if(props.publication.link === "confides"){
        link = <a href={confides} target="_blank" rel="noopener noreferrer">PDF</a>
    } else if(props.publication.link !== ""){
        link = <a href={props.publication.link} target="_blank" rel="noopener noreferrer">PDF</a>
    }

    let award = null;
    if (props.publication.award){
        award = <span className='badge-award'>{props.publication.award}</span>
    }

    return(
        <article className='publication'>
            <div className='publication-year'>{props.publication.year}</div>
            <div className='publication-body'>
                <h3 className='publication-title'>{props.publication.title}</h3>
                <div className='publication-authors'>{authors1}{spacer}{authors[bold_index]}{', '}{authors2}</div>
                <div className='publication-venue'>{props.publication.venue}</div>
                <div className='publication-meta'>
                    <span className='badge-type'>{props.publication.type}</span>
                    {award}
                    {link}
                    {repolink}
                </div>
            </div>
        </article>
    )
}

export default Publication;
